import { render, staticRenderFns } from "./IsMonthlySwitch.vue?vue&type=template&id=c885eeb4&scoped=true"
import script from "./IsMonthlySwitch.vue?vue&type=script&lang=ts"
export * from "./IsMonthlySwitch.vue?vue&type=script&lang=ts"
import style0 from "./IsMonthlySwitch.vue?vue&type=style&index=0&id=c885eeb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c885eeb4",
  null
  
)

export default component.exports